import { MDBCheckbox, MDBInput, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { ASParamEditorProps } from "../ASParamEditor";

/**
 * 25 x 4 bytes =  100 bytes
 * 17 x 4 numbers = 68 numbers
 * 
 * per prizeBox:
 *      - boxAttached: 1 byte x 8 => 8 bytes (8 numbers)
 *      - quantity: 2 bytes x 8 => 16 bytes (8 numbers)
 *      - prize: 1 byte x 1 => 1 byte (1 number) (bitmap 1x8)
 * 
 * [A0 A1 A2 A3 A4 A5 A6 A7] [Q0 Q1 Q2 Q3 Q4 Q5 Q6 Q7] [P0-7]
 * [A8 A9 A10 A11 A12 A13 A14 A15] [Q8 Q9 Q10 Q11 Q12 Q13 Q14 Q15] [P8-15]
 * [A16 ... A23] [Q16 ... Q23] [P16-23]
 * [A24 ... A31] [Q24 ... Q31] [P24-31]
 */

type PrizeParamData = {boxAttached: number, qnty: number, filled: boolean}[]

export const ASPrizeParam = ({currentValue, disabled, onCurrentValueChange}: ASParamEditorProps<PrizeParamData>) => {

    if (!currentValue) return null;

    return (
        <MDBTable className="table-sm" style={{}}>
            <MDBTableHead>
                <tr>
                    <th scope="col" style={{width: 100}}># Prize</th>
                    <th scope="col" style={{width: 100}}># Box</th>
                    <th scope="col" style={{width: 100}}>Quantity</th>
                    <th scope="col" style={{width: 100}}>Filled</th>
                </tr>
            </MDBTableHead>
            <MDBTableBody>
                {Array.from(new Array(32)).map((_,idx) => (
                    <tr key={idx}>
                        <th scope="row" style={{verticalAlign: 'middle'}}>
                            <span className="">Prize #{idx+1}</span>
                        </th>
                        <th style={{width: 100}}>
                            <MDBInput
                                type="number"
                                value={currentValue[idx].boxAttached+1}
                                disabled={disabled}
                                style={{height: 25}}
                                min={0}
                                onInput={ev => {
                                    const newData = [...currentValue];
                                    newData[idx].boxAttached = Math.max(0, Number(ev.currentTarget.value)-1);
                                    onCurrentValueChange(newData);
                                }}
                            />
                        </th>
                        <th scope="row" style={{verticalAlign: 'middle'}}>
                            <span>{currentValue[idx].qnty}</span>
                        </th>
                        <th scope="row" style={{verticalAlign: 'middle'}}>
                            <MDBCheckbox
                                type="checkbox"
                                checked={currentValue[idx].filled}
                                onChange={ev => {
                                    if (!currentValue) return;
                                    const newData = [...currentValue];
                                    newData[idx].filled = ev.currentTarget.checked;
                                    onCurrentValueChange(newData);
                                }}
                                label="Filled"
                                labelStyle={{lineHeight: 1.4}}
                                disabled={disabled}
                            />
                        </th>
                    </tr>
                ))}
            </MDBTableBody>
        </MDBTable>
    )
}